import { ExamineeModel } from "./../../examinees/examinee.model";
import { ExamineesService } from "./../../examinees/examinees.service";
import { Component, Input, OnInit } from "@angular/core";
import { FormGroup, Validators } from "@angular/forms";
import { Response } from "@angular/http/src/static_response";
import * as moment from "moment";
import { Observable } from "rxjs/Observable";

import { CommonService } from "../../services/common.service";
import { HeaderService } from "../../services/header.service";
import { Country } from "../../shared/models/country";
import { Request } from "../../shared/models/request";
import { ZipCode } from "../../shared/models/zipcode";
import { StepperComponent } from "../stepper/stepper.component";
import { ExamineeRequestService } from "./examinee-request.service";
import { ExamineeForm } from "./examinee.form";
import { DISABLED } from "@angular/forms/src/model";
@Component({
  selector: "app-examinee",
  templateUrl: "./examinee.component.html",
  styleUrls: ["./examinee.component.css"]
})
export class ExamineeComponent implements OnInit {
  public sasId: string;
  public aId: string;
  public tPin: string;
  public userGuidePdf: any;
  public signedReleasePdf: any;
  public isInvalidActId: boolean = false;
  frmExamine: FormGroup;
  formSubmitted = false;
  isNational = false;
  isInternational = false;
  countries: Country[];
  zips: ZipCode[];
  recordCount = "0";
  public date: any;
  public listExamineesData: ExamineeModel[] = [];
  public formError: any = {};
  public isActIdPresent: boolean = false;
  public msart1041: boolean = false;
  public continueRequest: boolean = false;

  @Input() savedRequest: Request;

  constructor(
    private examineesService: ExamineesService,
    private examineeForm: ExamineeForm,
    private examineeRequestService: ExamineeRequestService,
    private stepper: StepperComponent,
    public headerService: HeaderService,
    private _commonService: CommonService
  ) {}
  ngOnInit() {
    this.frmExamine = this.examineeForm.build();
    this.examineesService.searchExaminees({}).subscribe(
      data => {
        this.listExamineesData = data;
      },
      error => {}
    );
    if (sessionStorage.getItem("currentStudent")) {
      const studentDetails: any = JSON.parse(
        sessionStorage.getItem("currentStudent")
      );
      this.stepper.onRequestSave(studentDetails, false);
      this.savedRequest = studentDetails;
      this.examineeRequestService.currentRequest = studentDetails;
    }
    this.headerService.getSystemProperties().then(properties => {
      this.userGuidePdf = properties["TAA_USER_GUIDE_LINK"];
      this.signedReleasePdf = properties["SIGNED_RELEASE_LINK"];
    });

    this.headerService
      .getConfigPropertyValue("msart_1041")
      .subscribe((resp: any) => {
        if (resp.body === true) {
          this.msart1041 = true;
        }
      });

    Observable.forkJoin(
      this._commonService.getDynContent("SASID"),
      this._commonService.getDynContent("ACTID"),
      this._commonService.getDynContent("TAA_PIN")
    ).subscribe(([sasId, aId, tPin]) => {
      this.sasId = sasId;
      this.aId = aId;
      this.tPin = tPin;
    });
    if (this.savedRequest) {
      Observable.forkJoin([
        this.examineeRequestService.getCountries(),
        this.examineeRequestService.getExamineeRequest(
          this.savedRequest.requestId
        ),
        this.examineeRequestService.getPerson(this.savedRequest.personId),
        this.examineeRequestService.getPersonName(this.savedRequest.personId),
        this.examineeRequestService.getPersonAddress(
          this.savedRequest.personId
        ),
        this._commonService.getFinishedRecordCount(this.savedRequest.personId)
      ]).subscribe(
        ([
          countries,
          request,
          person,
          personName,
          personAddress,
          finishedRecordCount
        ]) => {
          this.countries = <Country[]>countries;
          const DOB = moment(
            person["body"][0]["BIRTH_DT"].substr(0, 10)
          ).format("L");

          let actId = "";
          if (
            person["body"][0]["EXT_PERSON_ID"] !== null &&
            person["body"][0]["EXT_PERSON_ID"] !== ""
          ) {
            actId = person["body"][0]["EXT_PERSON_ID"];
          } else {
            actId = person["body"][0]["ACT_ID"];
          }

          const formValue = {
            StudentId: person["body"][0]["STATE_SYSTEM_ID"],
            ACCOMMS_PIN: person["body"][0]["ACCOMMS_PIN"],
            ACTId: actId,
            FirstName: personName["body"][0]["FIRST_NM"],
            MiddleName: personName["body"][0]["MIDDLE_NM"],
            LastName: personName["body"][0]["LAST_NM"],
            DOB: DOB,
            Country: personAddress["body"][0]["COUNTRY_CD"],
            Address1: personAddress["body"][0]["STREET_1_AD"],
            Address2: personAddress["body"][0]["STREET_2_AD"]
          };

          const countryIndex = this.countries.findIndex(
            value => value.id === personAddress["body"][0]["COUNTRY_CD"]
          );
          if (countryIndex !== -1) {
            this.getCountrySelection(countryIndex + 1);
            if (this.isInternational) {
              formValue["InternationalZip"] =
                personAddress["body"][0]["ZIP_POSTAL_CD"];
              formValue["InternationalCity"] =
                personAddress["body"][0]["CITY_NM"];
            } else if (this.isNational) {
              formValue["NationalZip"] =
                personAddress["body"][0]["ZIP_POSTAL_CD"];
              formValue["NationalCity"] = personAddress["body"][0]["CITY_NM"];
              formValue["NationalState"] = personAddress["body"][0]["STATE_CD"];
              this.lookupZipCode(personAddress["body"][0]["ZIP_POSTAL_CD"]);
            }
          }
          this.frmExamine.patchValue(formValue);
          this.onChanges();
          this.recordCount = finishedRecordCount as any;
          if (this.recordCount !== "0") {
            this.frmExamine.disable();
          }
          if (
            this.msart1041 &&
            this.frmExamine.get("ACTId").value !== null &&
            this.frmExamine.get("ACTId").value !== "" &&
            request[0]["SUBMITTED_BY_NM"] !== null
          ) {
            this.isActIdPresent = true;
          }
        }
      );
    } else {
      this.examineeRequestService.getCountries().subscribe(data => {
        this.countries = data;
      });
      this.onChanges();
    }
  }

  onChanges(): void {
    if (
      this.frmExamine.get("ACTId") !== null &&
      this.frmExamine.get("ACTId").value !== ""
    ) {
      this.frmExamine.get("ACTId").valueChanges.subscribe((val: String) => {
        const submitActID = this.frmExamine
          .get("ACTId")
          .value.replace(/-/gi, "");
        if (submitActID.length === 8 || submitActID.length === 9) {
          for (let i = 0; i < this.listExamineesData.length; i++) {
            if (
              (this.listExamineesData[i].actId === submitActID ||
                this.listExamineesData[i].extPersonId === submitActID) &&
              !(
                moment(this.listExamineesData[i].dob).format("MM/DD/YYYY") ===
                  this.frmExamine.get("DOB").value &&
                this.listExamineesData[i].firstName.toUpperCase() ===
                  this.frmExamine.get("FirstName").value.toUpperCase() &&
                this.listExamineesData[i].lastName.toUpperCase() ===
                  this.frmExamine.get("LastName").value.toUpperCase()
              )
            ) {
              this.onOpenHandled("formErrorModal", this.listExamineesData[i]);
              break;
            }
          }
        }
      });
    }
    if (
      this.frmExamine.get("StudentId") !== null &&
      this.frmExamine.get("StudentId").value !== ""
    ) {
      this.frmExamine.get("StudentId").valueChanges.subscribe((val: String) => {
        const stateStudenttId = this.frmExamine
          .get("StudentId")
          .value.replace(/-/gi, "");
        for (let i = 0; i < this.listExamineesData.length; i++) {
          if (
            this.listExamineesData[i].studentId === stateStudenttId &&
            !(
              moment(this.listExamineesData[i].dob).format("MM/DD/YYYY") ===
                this.frmExamine.get("DOB").value &&
              this.listExamineesData[i].firstName.toUpperCase() ===
                this.frmExamine.get("FirstName").value.toUpperCase() &&
              this.listExamineesData[i].lastName.toUpperCase() ===
                this.frmExamine.get("LastName").value.toUpperCase()
            )
          ) {
            this.onOpenHandled("formErrorModal", this.listExamineesData[i]);
            break;
          }
        }
      });
    }
  }

  onOpenHandled(id, param) {
    document.getElementById(id).style.display = "block";
    this.formError = param;
  }

  checkDuplicate() {
    let isNotDuplicate: boolean = true;
    for (let i = 0; i < this.listExamineesData.length; i++) {
      if (
        this.continueRequest !== true &&
        this.frmExamine.get("ACCOMMS_PIN").value !==
          this.listExamineesData[i].taaPin &&
        ((this.frmExamine.get("StudentId").value !== null &&
          this.frmExamine.get("StudentId").value !== "" &&
          this.listExamineesData[i].studentId !== null &&
          this.listExamineesData[i].studentId.toUpperCase() ===
            this.frmExamine.get("StudentId").value.toUpperCase()) ||
            (this.frmExamine.get("ACTId").value !== null &&
          this.frmExamine.get("ACTId").value !== "" &&
          this.listExamineesData[i].actId ===
            this.frmExamine.get("ACTId").value))
      ) {
        this.onOpenHandled("formErrorModal", this.listExamineesData[i]);
        isNotDuplicate = false;
        break;
      }
      else if( this.continueRequest !== true &&
      this.frmExamine.get("ACCOMMS_PIN").value !==
      this.listExamineesData[i].taaPin &&
      ((this.frmExamine.get("StudentId").value !== null &&
          this.frmExamine.get("StudentId").value !== "" &&
          this.listExamineesData[i].actId ===
            this.frmExamine.get("StudentId").value.toUpperCase()) ||
            (this.frmExamine.get("ACTId").value !== null &&
          this.frmExamine.get("ACTId").value !== "" &&
          this.listExamineesData[i].studentId !== null &&
          this.listExamineesData[i].studentId.toUpperCase() ===
            this.frmExamine.get("ACTId").value) ||
      (moment(this.listExamineesData[i].dob).format("MM/DD/YYYY") ===
      this.frmExamine.get("DOB").value &&
      this.listExamineesData[i].firstName.toUpperCase() ===
        this.frmExamine.get("FirstName").value.toUpperCase() &&
      this.listExamineesData[i].lastName.toUpperCase() ===
        this.frmExamine.get("LastName").value.toUpperCase())) ) 
        {
        this.onOpenHandled("formErrorModal", this.listExamineesData[i]);
        isNotDuplicate = false;
        this.continueRequest = true;
        break;
      }
    }
    console.log(" isNotDuplicate " + isNotDuplicate);
    return isNotDuplicate;
  }

  saveExamineeData(proceed: boolean): void {
    this.formSubmitted = true;
    let btn = null;
    if (proceed) {
      btn = document.getElementById(
        "save_nc_button"
      ) as HTMLButtonElement | null;
    } else {
      btn = document.getElementById("save_button") as HTMLButtonElement | null;
    }
    if (btn != null) {
      btn.disabled = true;
    }

    if (this.frmExamine.valid && this.checkDuplicate()) {
      const newActId: string = this.frmExamine.get("ACTId").value;
      if (newActId) {
        this.frmExamine.controls["ACTId"].setValue(newActId.replace(/-/gi, ""));
      }
      this.saveExaminee(proceed, btn);
    } else {
      btn.disabled = false;
    }
  }

  saveExaminee(proceed: boolean, btn: HTMLButtonElement): void {
    const req = Object.assign(
      {},
      this.frmExamine.value,
      this.savedRequest || {}
    );
    this.examineeRequestService.saveExamineeRequest(req).subscribe(
      (data: any) => {
        if (data) {
          data.activeIdx = data.activeIdx - 1;
          sessionStorage.setItem("currentStudent", JSON.stringify(data));
          sessionStorage.setItem("examineeSubmitted", "true");
          this.stepper.onRequestSave(data, proceed);
          this.formSubmitted = false;
        }
      },
      (res: Response) => {
        if (res.status === 422) {
          const error = res.json().error;
          const codes = Object.keys(error.details.codes);
          codes.forEach(code => {
            btn.disabled = false;
            switch (code) {
              case "STATE_SYSTEM_ID":
                this.frmExamine.controls["StudentId"].setErrors({
                  pattern: "is not valid"
                });
                break;
              case "ACT_ID":
                this.frmExamine.setErrors({
                  invalidActIdPattern: "is not valid"
                });
                break;
              case "FIRST_NM":
                this.frmExamine.controls["FirstName"].setErrors({
                  fnm: "is not valid"
                });
                break;
              case "MIDDLE_NM":
                this.frmExamine.controls["MiddleName"].setErrors({
                  mnm: "is not valid"
                });
                break;
              case "LAST_NM":
                this.frmExamine.controls["LastName"].setErrors({
                  lnm: "is not valid"
                });
                break;
              case "BIRTH_DT":
                this.frmExamine.controls["DOB"].setErrors({
                  dob: "is not valid"
                });
                break;
              case "COUNTRY_CD":
                this.frmExamine.controls["Country"].setErrors({
                  ccd: "is not valid"
                });
                break;
              case "STREET_1_AD":
                this.frmExamine.controls["Address1"].setErrors({
                  sad: "is not valid"
                });
                break;
              case "STREET_2_AD":
                this.frmExamine.controls["Address2"].setErrors({
                  sadd: "is not valid"
                });
                break;
              case "ZIP_POSTAL_CD":
                this.frmExamine.controls["InternationalZip"]
                  ? this.frmExamine.controls["InternationalZip"].setErrors({
                      izip: "is not valid"
                    })
                  : this.frmExamine.controls["NationalZip"].setErrors({
                      zip: "is not valid"
                    });
                break;
              case "STATE_CD":
                this.frmExamine.controls["NationalState"].setErrors({
                  ste: "is not valid"
                });
                break;
              case "CITY_NM":
                this.frmExamine.controls["InternationalCity"]
                  ? this.frmExamine.controls["InternationalCity"].setErrors({
                      city: "is not valid"
                    })
                  : this.frmExamine.controls["NationalCity"].setErrors({
                      cty: "is not valid"
                    });
                break;
            }
          });
        }
      }
    );
  }

  lookupZipCode(zipcode: string) {
    this.frmExamine.patchValue({
      NationalCity: "",
      NationalState: undefined
    });
    this.examineeRequestService.lookupZipCode(zipcode).subscribe(zips => {
      this.zips = zips;
      this.zips.forEach(zip => {
        if (zip.preferredLastLineCityStateKey === zip.cityStateKey) {
          this.frmExamine.patchValue({
            NationalCity: zip.cityStateName,
            NationalState: zip.stateAbbrv
          });
        }
      });
    });
  }

  getCountrySelection(index) {
    if (index > 0) {
      index = index - 1;
      const value = this.countries[index].id;
      if (value === "US") {
        this.isNational = true;
        this.isInternational = false;
        this.frmExamine.get("NationalZip").setValidators([Validators.required]);
        this.frmExamine
          .get("NationalState")
          .setValidators([Validators.required]);
        this.frmExamine
          .get("NationalCity")
          .setValidators([Validators.required]);
        this.frmExamine.get("InternationalZip").setValidators([]);
        this.frmExamine.get("InternationalCity").setValidators([]);
      } else if (value) {
        this.isNational = false;
        this.isInternational = true;
        this.frmExamine.get("InternationalZip").setValidators([]);
        this.frmExamine
          .get("InternationalCity")
          .setValidators([Validators.required]);
        this.frmExamine.get("NationalZip").setValidators([]);
        this.frmExamine.get("NationalState").setValidators([]);
        this.frmExamine.get("NationalCity").setValidators([]);
      } else {
        this.isNational = false;
        this.isInternational = false;
      }
      this.frmExamine.patchValue({
        Address1: "",
        Address2: "",
        InternationalZip: "",
        InternationalCity: "",
        NationalZip: "",
        NationalState: "",
        NationalCity: ""
      });

      this.frmExamine.updateValueAndValidity();
    }
  }

  continue() {
    sessionStorage.setItem("examineeSubmitted", "true");
    this.stepper.goToNextStep();
  }
}



// WEBPACK FOOTER //
// ./client/views/request/examinee/examinee.component.ts